module.exports = __webpack_public_path__ + "img/aa.1fee5dc6.png";